import { DataCollectionFieldModel } from '../../pages/Assessment/types';

export type UnitSystemKey = 'metric' | 'imperial' | string;

export interface IUnitInfo {
  id: number;
  postfixText: string | null;
  description: string | null;
  system: UnitSystemKey;
}

export interface IUnitsMapping {
  byId: Record<number, IUnitInfo>;
  metricToImperial: Record<number, number>;
  imperialToMetric: Record<number, number>;
}

export const getDisplayUnitPostfix = (
  field: DataCollectionFieldModel,
  selectedSystem: UnitSystemKey | null | undefined,
  mapping: IUnitsMapping | null | undefined,
): string | null => {
  const originalPostfix =
    field?.Template?.Parameters?.MeasureDetail?.PostfixText ?? null;

  if (!mapping || !selectedSystem) {
    return originalPostfix;
  }

  const systemKey = selectedSystem.toLowerCase();
  if (systemKey !== 'metric' && systemKey !== 'imperial') {
    return originalPostfix;
  }

  const measureDetailId = field?.Template?.Parameters?.MeasureDetail_ID;
  if (typeof measureDetailId !== 'number') {
    return originalPostfix;
  }

  const currentUnit = mapping.byId[measureDetailId];
  if (!currentUnit) {
    return originalPostfix;
  }

  const currentSystem = (currentUnit.system || '').toLowerCase();

  if (
    (systemKey === 'metric' && currentSystem.includes('metric')) ||
    (systemKey === 'imperial' && currentSystem.includes('imperial'))
  ) {
    return currentUnit.postfixText ?? originalPostfix;
  }

  let targetUnitId: number | undefined;

  if (systemKey === 'metric') {
    targetUnitId = mapping.imperialToMetric[measureDetailId];
  } else if (systemKey === 'imperial') {
    targetUnitId = mapping.metricToImperial[measureDetailId];
  }

  if (!targetUnitId) {
    return currentUnit.postfixText ?? originalPostfix;
  }

  const targetUnit = mapping.byId[targetUnitId];
  if (!targetUnit) {
    return currentUnit.postfixText ?? originalPostfix;
  }

  return targetUnit.postfixText ?? currentUnit.postfixText ?? originalPostfix;
};


